var map = {
	"./admin.svg": "eab8",
	"./advertisements.svg": "98bb",
	"./announcements.svg": "2387",
	"./bus.svg": "81f4",
	"./cardRiding.svg": "c41b",
	"./cog-fill.svg": "5454",
	"./coupon.svg": "0c75",
	"./dashboard.svg": "f66a",
	"./dashboards.svg": "8f82",
	"./diandongche.svg": "f9c8",
	"./down.svg": "4b7a",
	"./feedback.svg": "77f0",
	"./level.svg": "52d6",
	"./many_people.svg": "7c26",
	"./multi-file.svg": "9344",
	"./new_orders.svg": "5d4c",
	"./password.svg": "c082",
	"./polygon.svg": "3478",
	"./profit.svg": "e40b",
	"./recharge.svg": "5897",
	"./repaire.svg": "2b64",
	"./repaired.svg": "1f15",
	"./roles.svg": "51db",
	"./single-file.svg": "67a5",
	"./sms.svg": "d466",
	"./tongzhigonggao.svg": "955f",
	"./total_orders.svg": "e071",
	"./total_profit.svg": "1803",
	"./upup.svg": "03ef",
	"./user.svg": "6ccd",
	"./work_order.svg": "70b8",
	"./yingxiaohuodong.svg": "42af",
	"./zijin.svg": "15be"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0820";